export function deepMerge(target: object, source: object): void {
  for (const key in source) {
    if (source.hasOwnProperty(key)) {
      const targetKey = key as keyof typeof target;
      const sourceKey = key as keyof typeof source;
      if (
        target.hasOwnProperty(key) &&
        typeof target[targetKey] === 'object' &&
        typeof source[sourceKey] === 'object'
      ) {
        deepMerge(target[targetKey], source[sourceKey]);
      } else {
        target[targetKey] = source[sourceKey];
      }
    }
  }
}
